import {createSvgIcon} from './utils'

export default createSvgIcon(
  <path
    clipRule="evenodd"
    d="M12 19C15.866 19 19 15.866 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19ZM12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16Z"
    fillRule="evenodd"
  />,
  'Destination',
)
